import { Check } from "@frui.ts/bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import ChargeConfirmationDialogViewModel from "viewModels/callCenter/actions/chargeConfirmationDialogViewModel";
import AlertWithIcon from "views/common/alertWithIcon";

const ChargeConfirmationDialogView: ViewComponent<ChargeConfirmationDialogViewModel> = observer(({ vm }) => {
  return (
    <Modal
      centered={true}
      show={vm.isOpened}
      onHide={vm.cancel}
      onEscapeKeyDown={vm.cancel}
      dialogClassName="confirm-dialog modal-lg"
      backdropClassName="confirm-dialog-backdrop">
      <Modal.Body className="justify-content-center text-center">
        <Modal.Title as="h3" className="mb-3">
          {vm.title}
        </Modal.Title>
        {vm.emailAddressChanged && (
          <AlertWithIcon variant="info" className="mb-4">
            {vm.translate("emailAddressChanged")}
          </AlertWithIcon>
        )}
        <div className="text-left" dangerouslySetInnerHTML={{ __html: vm.message }}></div>
        {vm.isBulkChargeOrder && (
          <div className="text-left">
            <Check
              className="mt-4 mb-3"
              custom
              type="radio"
              target={vm}
              property="sendConfirmationForSingleChargeOnly"
              value={true}
              label={vm.translate("sendConfirmationForSingleChargeOnly")}
            />
            <Check
              className="mt-3 mb-2"
              custom
              type="radio"
              target={vm}
              property="sendConfirmationForSingleChargeOnly"
              value={false}
              label={vm.translate("sendConfirmationForAllChargesInOrder")}
              disabled={vm.emailAddressChanged}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button size="sm" onClick={vm.cancel} variant="light">
          {vm.localizationService.translateGeneral("confirmDialog.cancel")}
        </Button>
        <Button size="sm" onClick={vm.confirm} variant="primary">
          {vm.translate("confirm")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default registerView(ChargeConfirmationDialogView, ChargeConfirmationDialogViewModel);
